import router from '@/router'
import routerUtil from '@utils/routerUtil'
import { Message } from 'element-ui'

let routerReloadCount = 0;
/**
 * 路由监听
 */
router.beforeEach((to, from, next) => {

	/**
	 * 如跳转到登录页面，直接跳转。
	 */
	if (to.path === '/login') {
		//修改标题
		document.title = "分发中心";
		next();
		return;
	}

	if(to.path.indexOf('/mobile/logistics/info') != -1){
		//修改标题
		document.title = "物流轨迹";
		next();
		return;
	}

	if(to.path.indexOf('/mobile/pay/success') != -1){
		//修改标题
		document.title = "支付成功";
		next();
		return;
	}

	/**
	 * 如果为手机页面直接过
	 */
	if(to.path.indexOf('/mobile') != -1){
		//修改标题
		document.title = "案件辅助填写";
		next();
		return;
	}

	/**
	 * 如果为share页面直接过
	 */
	if(to.path === '/' ||  to.path.indexOf('/share/download') != -1){
		//修改标题
		document.title = "app下载";
		next();
		return;
	}

	if (to.path.indexOf('/riskAssessment') != -1) {
		document.title = "风险评估";
		next();
		return;
	}
	
	/**
	 * unshare
	 */
	 if(to.path.indexOf('/unshare') != -1){
		//修改标题
		document.title = "加载失败";
		next();
		return;
	}

	if (to.path.indexOf('/bi') != -1) {
		document.title = "德启产品动态监控";
		next();
		return;
	}

	if (to.path.indexOf('/biApp') != -1) {
		document.title = "德启产品动态监控";
		next();
		return;
	}

	/**
	 * 验证是否登录，且判断登录是否超时。
	 * 超时时间(1小时)
	 */
	if(localStorage.dq_center_u_tk && localStorage.dq_center_li_time) {
		let curTime = new Date().getTime();
		let overdue = (curTime - localStorage.dq_center_li_time) / (1000*60*60) > 1;
		if (overdue) {
			Message({
				message: '用户授权超时，请重新登录！',
				type: 'warning',
				duration: 5 * 1000
			})
			next('/login');
			return;
		}
	} else {
		next('/login');
		return;
	}

	/**
	 * 1、如未匹配到正确的路由，重新加载路由，重新跳转。
	 * 2、如未匹配到且已经重新加载过路由，跳转404页面。
	 **/
	let routerMatchObj = router.match(to);
	let matchFlag = routerMatchObj.matched && routerMatchObj.matched.length > 0;
	if (!matchFlag) {
		if (routerReloadCount === 0) {
			routerReloadCount++;
			routerUtil.loadRouterByMenus();
			if (!!to.name) {
				router.push({name: to.name})
			}
			if (!!to.path) {
				router.push({path: to.path})
			}
		} else if (routerReloadCount > 0) {
			routerReloadCount = 0;
			next();
			router.push({name: '404'});
		}
	}
	routerReloadCount = 0;
	next();
});



// WEBPACK FOOTER //
// ./src/permission.js